import { Box, Container, Typography } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { Trans } from 'react-i18next';

const firstDivContent = {
  display: 'flex',
  marginRight: -15,
  marginLeft: -15,
  justifyContent: 'space-between!important',
  alignItems: 'flex-start!important',
};

const boxStyle = {
  flex: '0 0 25%',
  maxWidth: '25%',
};

const titleInFooter = {
  fontSize: '.875rem',
  fontWeight: '700',
  color: '#fff',
  margin: 0,
};

const footerDetails = {
  fontSize: 11
};

const lineSep = {
  verticalAlign: 'top'
};

const pDetails = {
  fontSize: '.6375rem',
  lineHeight: '1.7',
  marginBottom: '0.3rem',
  color: '#fff',
  textDecoration: 'none'
}

function Footer() {
  const { REACT_APP_VERSION } = process.env;
  return (
    <div
      style={{
        color: '#ffffff',
        backgroundColor: '#2d2927',
        width: '100%'
      }}
    >
      <Container maxWidth="lg" >
        <Box
          style={firstDivContent}
          py={3}
          display={{ xs: 'block', md: 'flex' }}
          textAlign={{ xs: 'center', md: 'left' }}
          justifyContent="space-between"
        >
          <Box
            style={boxStyle}
          >
            <h6 style={titleInFooter} ><Trans>footer.sites</Trans></h6>
            <img
              alt="Ligne vert"
              src="/static/images/tools/Ligne 3.svg"
              style={lineSep}
            />
            <Typography style={footerDetails}>
              <p style={pDetails}><a style={pDetails} href="https://astekgroup.fr/" target="_blank">Astekgroup</a></p>
              <p style={pDetails}><a style={pDetails} href="https://astekjob.fr/" target="_blank">Astekjob</a></p>
            </Typography>
          </Box>
          <Box style={boxStyle} >
            <h6 style={titleInFooter} ><Trans>footer.followUs</Trans></h6>
            <img
              alt="Ligne vert"
              src="/static/images/tools/Ligne 3.svg"
              style={lineSep}
            />
            <Typography style={footerDetails}>
              <InstagramIcon />
              <TwitterIcon />
              <FacebookIcon />
              <LinkedInIcon />
            </Typography>
          </Box>
          <Box style={boxStyle} >
            <h6 style={titleInFooter} ><Trans>footer.contact</Trans></h6>
            <img
              alt="Ligne vert"
              src="/static/images/tools/Ligne 3.svg"
              style={lineSep}
            />
            <Typography style={footerDetails}>
              <p style={pDetails} >77-81ter, rue Marcel Dassault</p>
              <p style={pDetails} >92100 Boulogne-Billancourt</p>
              <p style={pDetails} ><a href="mailto:contact@groupeastek.fr" style={pDetails}>contact@groupeastek.fr</a></p>
            </Typography>
          </Box>
          <Box style={boxStyle} >
            <Typography align="center">
              <img
                alt="logo"
                src="/static/images/logo/ASTEK - PYR.svg"
              />
              <p style={pDetails} >&copy; 2022 Astek | <Trans>footer.legalNotice</Trans></p>
              <p style={pDetails} >My Skills {REACT_APP_VERSION}</p>
            </Typography>
          </Box>
        </Box>
      </Container>
    </div>
  );
}

export default Footer;
